// @ts-ignore
 
import request from "src/lib/axios";

/** 获取 HQ 角色列表 GET /api/v1/hq/role */
export async function HqRoleControllerListV1(options?: { [key: string]: any }) {
  return request<MyApi.ApiResponseOutputRoleDtoArray>("/api/v1/hq/role", {
    method: "GET",
    ...(options || {}),
  });
}

/** 创建 HQ 角色 POST /api/v1/hq/role */
export async function HqRoleControllerCreateV1(
  body: MyApi.CreateRoleDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRoleDto>("/api/v1/hq/role", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取 HQ 角色详情 GET /api/v1/hq/role/${param0} */
export async function HqRoleControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqRoleControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputRoleDto>(`/api/v1/hq/role/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 更新 HQ 角色 PUT /api/v1/hq/role/${param0} */
export async function HqRoleControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqRoleControllerUpdateV1Params,
  body: MyApi.UpdateRoleDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputRoleDto>(`/api/v1/hq/role/${param0}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 删除 HQ 角色 DELETE /api/v1/hq/role/${param0} */
export async function HqRoleControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqRoleControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(`/api/v1/hq/role/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 设置 HQ 角色权限 PUT /api/v1/hq/role/${param0}/permissions */
export async function HqRoleControllerSetPermissionsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqRoleControllerSetPermissionsV1Params,
  body: MyApi.SetRolePermissionsDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputRoleDto>(
    `/api/v1/hq/role/${param0}/permissions`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取权限清单（只读） GET /api/v1/hq/role/permissions */
export async function HqRoleControllerPermissionsV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputPermissionDtoArray>(
    "/api/v1/hq/role/permissions",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}
